// The clinic whose name the sign-in page shows: from its link (/c/:slug), or remembered on this device after a
// sign-in so plain /login on a front-desk computer still says whose system it is.

/** logo: the logo's version when the clinic has one (see clinicLogoUrl), null when it has none */
export interface ClinicBrand { name: string; slug?: string | null; logo?: number | null }

const KEY = 'clinic-brand';

export function getRememberedBrand(): ClinicBrand | null {
  try {
    const b = JSON.parse(localStorage.getItem(KEY) || 'null');
    return b && typeof b.name === 'string' && b.name.trim() ? b : null;
  } catch { return null; }
}

export function rememberBrand(brand: ClinicBrand | null) {
  try {
    if (brand?.name?.trim()) localStorage.setItem(KEY, JSON.stringify({ name: brand.name.trim(), slug: brand.slug || null, logo: brand.logo ?? null }));
    else localStorage.removeItem(KEY);
  } catch { /* storage unavailable: the page just shows the plain sign-in */ }
}

// The last email signed in with "Keep me signed in" ticked: filled in next time. A sign-in without it clears the
// email, so a shared computer keeps none.
const EMAIL_KEY = 'last-signin-email';

export function getRememberedEmail(): string {
  try { return localStorage.getItem(EMAIL_KEY) || ''; } catch { return ''; }
}

export function rememberEmail(email: string | null) {
  try {
    if (email) localStorage.setItem(EMAIL_KEY, email);
    else localStorage.removeItem(EMAIL_KEY);
  } catch { /* storage unavailable: the email box just starts empty */ }
}

/** The address staff open to reach their clinic's sign-in page */
export function loginLinkUrl(slug: string) {
  return `${window.location.origin}/c/${slug}`;
}
